import { request } from './http';
import type { LoginRequest, LoginResponse, UserProfile } from '@/types/user';

export const authApi = {
  /** 登录 */
  login(payload: LoginRequest) {
    return request<LoginResponse>({ url: '/auth/login', method: 'POST', data: payload });
  },
  /** 登出 */
  logout() {
    return request<void>({ url: '/auth/logout', method: 'POST' });
  },
  /** 当前登录用户 */
  me() {
    return request<UserProfile>({ url: '/auth/me', method: 'GET' });
  },
  /** 修改密码 */
  changePassword(payload: { oldPassword: string; newPassword: string }) {
    return request<void>({ url: '/auth/password', method: 'PUT', data: payload });
  },
  /** 更新联系信息 */
  updateContact(payload: { email?: string; phone?: string }) {
    return request<UserProfile>({ url: '/auth/profile', method: 'PUT', data: payload });
  },
  /** 二次安全验证：用支付密码换取一次性 step-up token */
  stepUp(payload: { payPassword: string; scenario: string }) {
    return request<{ token: string; expiresIn: number }>({
      url: '/auth/step-up',
      method: 'POST',
      data: payload,
    });
  },
};
